/* eslint-disable no-underscore-dangle */
import React from 'react'

// Components
import BannerShell from 'components/flex/Banner/BannerShell'
import FormShell from 'components/flex/Form/FormShell'
import TextShell from 'components/flex/Text/TextShell'
import PostsShell from 'components/flex/Posts/PostsShell'
import Fragment from 'components/flex/Fragment'
import PackagesShell from 'components/flex/Packages/PackagesShell'
import ImageShell from 'components/flex/Image/ImageShell'
import SliderShell from 'components/flex/Slider/SliderShell'
import ServicesShell from 'components/flex/Services/ServicesShell'
import Reserve from 'components/flex/Reserve'
import AfterOrder from 'components/flex/AfterOrder'
import TeamShell from 'components/flex/Team/TeamShell'
import Privacy from 'components/flex/Privacy'
import Calendly from 'components/flex/Calendly'
import Video from 'components/flex/Video'
import Hero from 'components/flex/Hero'
import CasesShell from 'components/flex/Cases/CasesShell'

interface FlexContentProps {
  prefix?: string
  fields: any
  location?: any
}

interface FlexerProps {
  [key: string]: any
}

interface ComponentProps {
  fields: any
  location?: any
}

const FlexContentHandler: React.FC<FlexContentProps> = ({
  prefix = 'page_Flexcontent',
  fields,
  location = {},
}) => {
  if (!fields) {
    return null
  }

  const flexers: FlexerProps = {
    [`${prefix}_Flex_Banner`]: BannerShell,
    [`${prefix}_Flex_Form`]: FormShell,
    [`${prefix}_Flex_Text`]: TextShell,
    [`${prefix}_Flex_PostTypes`]: PostsShell,
    [`${prefix}_Flex_Cases`]: CasesShell,
    [`${prefix}_Flex_Fragment`]: Fragment,
    [`${prefix}_Flex_Packages`]: PackagesShell,
    [`${prefix}_Flex_Image`]: ImageShell,
    [`${prefix}_Flex_Slider`]: SliderShell,
    [`${prefix}_Flex_Services`]: ServicesShell,
    [`${prefix}_Flex_Reserve`]: Reserve,
    [`${prefix}_Flex_AfterOrder`]: AfterOrder,
    [`${prefix}_Flex_Team`]: TeamShell,
    [`${prefix}_Flex_Privacystatement`]: Privacy,
    [`${prefix}_Flex_Calendly`]: Calendly,
    [`${prefix}_Flex_Video`]: Video,
    [`${prefix}_Flex_Hero`]: Hero,
  }

  if (!fields.flex) {
    return null
  }

  return (
    <>
      {fields.flex.map((section: any, index: number) => {
        if (!section.fieldGroupName || !flexers[section.fieldGroupName]) {
          return null
        }

        const Component: React.FC<ComponentProps> =
          flexers[section.fieldGroupName]

        return (
          <Component
            // eslint-disable-next-line react/no-array-index-key
            key={`${location ? location.pathname : 'flex'}-${index}`}
            fields={section}
            location={location}
          />
        )
      })}
    </>
  )
}

export default FlexContentHandler
